import { motion } from "motion/react";

export function Process() {
  const steps = [
    { title: "Fit Check", desc: "Align on Goals & Scope." },
    {
      title: "Framing",
      desc: "Clarify what should be Solved.",
    },
    { title: "Blueprint", desc: "Lock Roadmap & Tech." },
    { title: "Design", desc: "Prepare and Plan the Product." },
    {
      title: "Build",
      desc: "Ship in Milestones based on Priority.",
    },
    { title: "Launch", desc: "Go live with Monitoring." },
    { title: "Evolve", desc: "Consult, Maintain & Scale." },
  ];

  return (
    <section
      id="process"
      className="py-16 md:py-24 bg-slate-900 text-white relative overflow-hidden"
    >
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
        <div className="absolute top-[20%] left-[10%] w-64 h-64 bg-[#FD5750] rounded-full blur-[100px]"></div>
        <div className="absolute bottom-[20%] right-[10%] w-80 h-80 bg-blue-500 rounded-full blur-[100px]"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20">
          <span className="text-[#FD5750] font-bold text-sm tracking-widest uppercase mb-2 block">
            Our Methodology
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            The 7-Step Success Framework
          </h2>
          <p className="text-slate-400 text-lg">
            A proven psychological and technical model designed
            to deliver consistent, high-impact results.
          </p>
        </div>

        <div className="relative mt-16 md:mt-24">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-[22px] left-0 w-full h-0.5 bg-slate-700 z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-7 gap-y-12 gap-x-4">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.1,
                }}
                viewport={{ once: true }}
                className="relative z-10 flex flex-col items-center text-center group"
              >
                <div className="w-12 h-12 rounded-full bg-slate-800 border-2 border-slate-600 flex items-center justify-center font-bold text-lg mb-6 group-hover:border-[#FD5750] group-hover:bg-[#FD5750] transition-colors duration-300 shadow-lg shadow-black/20 relative z-20">
                  {index + 1}
                </div>
                <h3 className="font-bold text-lg mb-2 text-white group-hover:text-[#FD5750] transition-colors">
                  {step.title}
                </h3>
                <p className="text-xs text-slate-400 max-w-[120px] mx-auto leading-relaxed">
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}